import React from "react";

export default function IconSearch({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="search_google">
        <path
          id="Vector"
          d="M17.4222 17.5L11.8222 12.25C11.3777 12.5833 10.8666 12.8472 10.2888 13.0417C9.71107 13.2361 9.09626 13.3333 8.4444 13.3333C6.82959 13.3333 5.46292 12.809 4.3444 11.7604C3.22589 10.7118 2.66663 9.43056 2.66663 7.91667C2.66663 6.40278 3.22589 5.12153 4.3444 4.07292C5.46292 3.02431 6.82959 2.5 8.4444 2.5C10.0592 2.5 11.4259 3.02431 12.5444 4.07292C13.6629 5.12153 14.2222 6.40278 14.2222 7.91667C14.2222 8.52778 14.1185 9.10417 13.9111 9.64583C13.7037 10.1875 13.4222 10.6667 13.0666 11.0833L18.6666 16.3333L17.4222 17.5ZM8.4444 11.6667C9.55551 11.6667 10.5 11.3021 11.2777 10.5729C12.0555 9.84375 12.4444 8.95833 12.4444 7.91667C12.4444 6.875 12.0555 5.98958 11.2777 5.26042C10.5 4.53125 9.55551 4.16667 8.4444 4.16667C7.33329 4.16667 6.38885 4.53125 5.61107 5.26042C4.83329 5.98958 4.4444 6.875 4.4444 7.91667C4.4444 8.95833 4.83329 9.84375 5.61107 10.5729C6.38885 11.3021 7.33329 11.6667 8.4444 11.6667Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
